import { STORE_VIEWS_ACTIONS } from './storeViews.types'

/**
 *
 * @param {import('./storeViews.types').StoreViewsSlice['status']} payload
 * @returns {import('./storeViews.types').StoreViewsStatusAction}
 */
export const setStoreViewsStatusAction = payload => ({ type: STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_STATUS, payload })

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./storeViews.types').StoreViewsErrorsAction}
 */
export const setStoreViewsErrorsAction = payload => ({ type: STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_ERRORS, payload })

/**
 *
 * @param {import('./storeViews.types').StoreView} payload
 * @returns {import('./storeViews.types').StoreViewsCurrentAction}
 */
export const setStoreViewsCurrentAction = payload => {
  localStorage.setItem('currentlocationId', payload.id)

  return { type: STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_CURRENT, payload }
}

/**
 * @param {import('./storeViews.types').StoreView[]} payload
 * @returns {import('./storeViews.types').StoreViewsAvailableAction}
 */
export const setStoreViewsAvailableAction = payload => ({
  type: STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_AVAILABLE,
  payload
})

/**
 * @returns {import('./storeViews.types').StoreViewsClearAction}
 */
export const clearStoreViewsErrorsAction = () => ({ type: STORE_VIEWS_ACTIONS.CLEAR_STORE_VIEWS_ERRORS })

/**
 * @returns {import('./storeViews.types').StoreViewsClearAction}
 */
export const clearStoreViewsCurrentAction = () => ({ type: STORE_VIEWS_ACTIONS.CLEAR_STORE_VIEWS_CURRENT })

/**
 * @returns {import('./storeViews.types').StoreViewsClearAction}
 */
export const clearStoreViewsAvailableAction = () => ({ type: STORE_VIEWS_ACTIONS.CLEAR_STORE_VIEWS_AVAILABLE })
